import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiMessageService} from '../../core/api-message.service';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {Cruscotto} from './cruscotto.model';
import {ConfigService} from '../../core/config.service';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';
import {HttpParams} from '@angular/common/http';
import { PrincipalService } from '../../common/controller/principal.service';

@Injectable()
export class CruscottoService extends PrincipalService<Cruscotto> {

  public static ROUTE = 'cruscotto';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Cruscotto {
    return JsonBaseBuilder.jsonToCruscotto(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return CruscottoService.ROUTE;
  }

  public getAllRuoliAttivi(utenteId: number): Observable<Cruscotto[]> {
    return this.getArray( '/ruoliAttivi', new HttpParams().set('idUtente', utenteId + ''));
  }
}
